export const Disabled = () => null;

export default Disabled;
